import React, { useEffect, useState } from 'react'
import { Main } from '../components/frame/main';
import { Link, useParams } from "react-router-dom";
import { List } from 'components/pages-galeri-video-list/list';
import { Pagination } from 'components/utils/pagination';
import { SideMenu } from 'components/utils/side-menu';
import { handleError, handleLongText, slugToTitleCase } from 'config/libraries';
import ReactPaginate from 'react-paginate';
import { NoData } from 'components/pages-informasi/no-data';

export const GaleriVideoList = () => {

    let { slug } = useParams();
    const [DataResponse, setDataResponse] = useState(null);
    const [FadeClassName, setFadeClassName] = useState('fade-costum hide');
    const [Pagination, setPagination] = useState({
        pageCount: 0,
        currentPage: 1
    });
    useEffect(() => {

        setFadeClassName('fade-costum hide')
        getDataResponse(1);
        
        return () => {
            setDataResponse(null);
            setFadeClassName('fade-costum hide');
        };
    }, [slug]);

    function getDataResponse(page = 1) {
        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/galeri-video?per_page=10&page=' + page).then(function (response) {
            setDataResponse(response.data.data.data);
            setPagination({
                pageCount: response.data.data.last_page,
                currentPage: response.data.data.current_page
            })
            setTimeout(() => {
                setFadeClassName('fade-costum')
            }, 300);
        }).catch(function (error) {
            handleError(error)
        })
    }

    function handlePageClick(params) {
        getDataResponse(parseInt(params.selected) + 1);
        setDataResponse(null);
        setFadeClassName('fade-costum hide');
    }

    return (
        <Main>
            <section id="content_main " className={'clearfix jl_post_loop_wrapper ' + FadeClassName}>
            {(DataResponse !== null && DataResponse.length > 0) ?
                <div className="container margin-list">
                    <div className="row">
                        <div className="col-md-12 grid-sidebar" id="content">
                            <div className="jl_wrapper_cat">
                                <div className="row">
                                    {(DataResponse !== null ? <List response={DataResponse}/> : '')}
                                </div>
                                <nav className="jellywp_pagination">
                                {
                                        (DataResponse != null && DataResponse.length > 0) ?
                                        (Pagination.pageCount > 1) ? 
                                        <div className="container-pagination">
                                            <ReactPaginate
                                                breakLabel="..."
                                                nextLabel="next >"
                                                onPageChange={handlePageClick}
                                                pageRangeDisplayed={5}
                                                forcePage={parseInt(Pagination.currentPage) - 1}
                                                pageCount={Pagination.pageCount}
                                                containerClassName={'pagination'}
                                                subContainerClassName={'pages pagination'}
                                                activeClassName={'active'}
                                                previousLabel="< previous"
                                                renderOnZeroPageCount={null}
                                            />
                                        </div> : <p className='no-data-pagination'>Seluruh data sudah ditampilkan !...</p> : ''
                                    }
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                 : <NoData slug={'galeri-video'}/>}
            </section>
        </Main>
    )
};